import React, { useContext, useState } from 'react'
import styles from './PasswordOnly.module.css'
import { FormTitle } from '../../../Common/FormTitle'
import { NextButton } from '../../../Common/CtaButton/NextButton'
import { HandleBlurFunction } from '../LoginInformation/types'
import { useAbTestGtm } from '../../../../hooks/useAbTestGtm'
import { StepContext } from '../../StepContainer'
import { validatePassword } from '../LoginInformation/validate'
import { PasswordField } from '../JobSeeker/BasicInformation/PasswordField'
import { PASSWORD_CONSTRAINTS } from '../../../../constants/progressBanner'

// DEV-3482: B/Cパターン専用。Aパターンの LoginInformation（メール+パスワード同居）を
// パスワードのみのステップに分割したもの。入力欄はJobSeekerPasswordOnlyと同じPasswordFieldを再利用する
export const PasswordOnly = () => {
    const { dataClickLabel, dataViewLabel } = useAbTestGtm()
    const { formState } = useContext(StepContext)

    const [password, setPassword] = useState(formState.password || '')
    const [passwordTouched, setPasswordTouched] = useState({ password: false })

    // validatePasswordは同期関数なので描画時に求める。stateとuseEffectを挟むと、
    // 入力を貼り付けた直後の1フレームだけ前回のエラー（空）で「次へ」が有効になり、
    // その間にクリックされると大小英数字を満たさないパスワードで先へ進める
    const passwordErrors = {
        password: validatePassword(password, passwordTouched.password) || '',
    }

    const handlePasswordBlur: HandleBlurFunction = field => {
        setPasswordTouched(prev => ({
            ...prev,
            [field]: true,
        }))
    }

    const isFormValid =
        password.length >= PASSWORD_CONSTRAINTS.MIN_LENGTH &&
        !passwordErrors.password

    return (
        <div className={styles.wrapper}>
            <div className={styles.selectionWrapper}>
                <FormTitle
                    formTitleText="パスワードを決めましょう"
                    dataViewLabel={dataViewLabel('EF_StepForm_パスワード')}
                    dataClickLabel={dataClickLabel(
                        'EF_StepForm_パスワード-戻る'
                    )}
                />

                <PasswordField
                    password={password}
                    setPassword={setPassword}
                    passwordErrors={passwordErrors}
                    onBlur={handlePasswordBlur}
                    dataClickLabel={dataClickLabel}
                    showLoginLink={false}
                    // DEV-3482: Aの LoginInformation と同じく表示切替を出す（Figma 2254:13884）
                    showVisibilityToggle
                />

                <NextButton
                    formKey={['password']}
                    formValue={[password]}
                    displayFormKey={['password']}
                    // 伏せるのは確認画面側の責務（ContentConfirmation/BasicInformation が
                    // 「パスワードを表示する」で出し分ける）。ここで伏せると、Aと違って
                    // チェックを入れても伏せ字のままになり入力を見直せない
                    displayFormValue={[password]}
                    isDisabled={!isFormValid}
                    dataClickLabel={dataClickLabel(
                        'EF_StepForm_パスワード-次へ'
                    )}
                />
            </div>
        </div>
    )
}
